import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCarousel,{attrs:{"continuous":"","cycle":"","hide-delimiter-background":"","show-arrows-on-hover":"","delimiter-icon":"mdi-minus","height":"100%"}},_vm._l((_vm.slides),function(slide,i){return _c(VCarouselItem,{key:i,attrs:{"eager":""}},[_c(VImg,{attrs:{"src":slide,"alt":_vm.slideAlt(i),"eager":""}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }